import _ from 'lodash';
import { safeToBig } from 'shared/helpers/utils_math';
import { getProductNetWeightInGrams } from 'shared/helpers/products';
import { getTypeLimits, getLimitMessage, getEffectiveSubcategories, isPurchaseLimitTypeOverrideEnforced } from '../utils';
export function isSolidEdible(product) {
    var useMultiSubcategories = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, purchaseLimitTypeOverrideIsEnforced = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    // A finite routed purchaseLimitType is exclusive. If the jurisdiction does not cap that purchaseLimitType,
    // retain the physical-form limit so customer routing cannot create an unlimited legal category.
    if (product.purchaseLimitTypeOverride && purchaseLimitTypeOverrideIsEnforced) return false;
    var type = product.type;
    var isLiquid = _.includes(getEffectiveSubcategories(product, useMultiSubcategories), 'drinks');
    return type === 'Edible' && !isLiquid;
}
export function checkSolidEdibleNetWeight(cart) {
    var getFlowerEquivalent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
        return 0;
    };
    var solidEdibleNetWeightLimit = getTypeLimits(cart).solidEdibleNetWeightLimit;
    var weightInGrams = getTotalSolidGramsForCart(cart, getFlowerEquivalent);
    var message = getLimitMessage('solid edibles', solidEdibleNetWeightLimit);
    return weightInGrams > solidEdibleNetWeightLimit ? {
        total: weightInGrams,
        message: message,
        withinLimits: false
    } : {
        withinLimits: true
    };
}
export function getTotalSolidGramsForCart(param) {
    var orders = param.orders, state = param.state, limits = param.limits, medical = param.medical, useMultiSubcategories = param.useMultiSubcategories, getFlowerEquivalent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
        return 0;
    };
    var enforcementContext = {
        limits: limits,
        medical: medical,
        useMultiSubcategories: useMultiSubcategories
    };
    return Number(_.reduce(orders, function(previous, order) {
        var product = order.product, quantity = order.quantity;
        if (!isSolidEdible(product, useMultiSubcategories, isPurchaseLimitTypeOverrideEnforced(product, enforcementContext))) {
            return safeToBig(previous);
        }
        var netWeightInGrams = getProductNetWeightInGrams(product);
        var totalNetWeight = netWeightInGrams * quantity;
        var isBritishColumbiaDispensary = state === 'BC';
        var flowerEquivalent = isBritishColumbiaDispensary ? getFlowerEquivalent(order, medical, limits, useMultiSubcategories) : 0;
        var useEquivalent = !!flowerEquivalent;
        return safeToBig(previous).plus(useEquivalent ? flowerEquivalent : totalNetWeight);
    }, 0.0));
}
